var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"sticky",style:({height: _vm.height})},[_c('div',{class:{'Affix-fixed':_vm.isSticky},style:({top: _vm.offset+'px', width: _vm.width})},[_vm._t("default",null,{"isSticky":_vm.isSticky})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }